import { menu } from 'resolutions/all/menu'
import { removeClass } from 'MK/DOM/fns/classList/remove'

export const unloadSubMenu = (event) => {
  if (MK.active.resolution !== 'desktop') return

  try {
    if (!menu.submenu) return
    menu.submenu.innerHTML = ''
    removeClass(menu.submenu, 'show')
  } catch (error) {
    console.log(error)
    console.log('!!! ERROR (resolutions.desktop.unloadSubMenu) Error encountered while unloading desktop submenu.')
    console.log('Event:')
    console.log(event)
    console.log('SubMenu:')
    console.log(menu.submenu)
    MK.captureException(error)
  }
}
